module.exports = __webpack_public_path__ + "img/MES12Indice3_cutout.d1b6177d.png";